<script setup>
import { useI18n } from 'vue-i18n';
import { REPLY_EDITOR_MODES } from './constants';

defineProps({
  mode: {
    type: String,
    default: REPLY_EDITOR_MODES.REPLY,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['setMode']);
const { t } = useI18n();

const modes = [
  {
    key: REPLY_EDITOR_MODES.REPLY,
    label: t('CONVERSATION.REPLYBOX.REPLY'),
  },
  {
    key: REPLY_EDITOR_MODES.NOTE,
    label: t('CONVERSATION.REPLYBOX.PRIVATE_NOTE'),
  },
  {
    key: REPLY_EDITOR_MODES.TASK,
    label: t('CONVERSATION.REPLYBOX.TASK'),
  },
];
</script>

<template>
  <div
    class="flex items-center h-8 p-1 border rounded-full bg-n-alpha-2"
    :class="{ 'opacity-60': disabled }"
  >
    <button
      v-for="editorMode in modes"
      :key="editorMode.key"
      type="button"
      class="px-3 h-6 text-xs rounded-full transition-colors"
      :class="{
        'bg-n-solid-1 text-n-slate-12 shadow-sm': mode === editorMode.key,
        'text-n-slate-11': mode !== editorMode.key,
        'cursor-not-allowed': disabled,
      }"
      :disabled="disabled && editorMode.key === REPLY_EDITOR_MODES.REPLY"
      @click="emit('setMode', editorMode.key)"
    >
      {{ editorMode.label }}
    </button>
  </div>
</template>
